import sum from 'ml-array-sum';
/**
 * Computes the mean of the given values.
 */
export default function mean(array) {
    return sum(array) / array.length;
}
//# sourceMappingURL=index.js.map